/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';
import { Button } from 'antd';
import './animation044.less';

import ImgPoint from '../../../../../assets/animation_point.gif';
import ImgArrowRight from '../../../../../assets/arrow-right.png';
import ImgArrowLeft from '../../../../../assets/arrow-left.png';

interface IAnimation044Items {
  name: string;
  img: string;
  text: string;
}

interface IAnimation044Props {
  items: IAnimation044Items[];
  className: string;
  onCompleted?: () => void;
}

const Animation044: React.FunctionComponent<IAnimation044Props> = ({
  items,
  className,
  onCompleted,
}) => {
  const getImg = (img: string) =>
    require(`../../../../../assets/${img}`).default;
  const [state, setState] = React.useState({
    step: 1,
    completed: false,
    secureWarning: 1,
    secureWarningCompleted: false,
  });
  const swithStep = (step: number) => {
    const nextStep = state.step + step;
    setState({
      ...state,
      step: nextStep,
      completed: nextStep >= 3 ? true : state.completed,
    });
    if (nextStep >= 3) {
      onCompleted && onCompleted();
    }
  };
  return (
    <div className={`hacker-steps component ${className}`}>
      <Button
        className={`prev-button ${state.step === 1 ? 'hide' : ''}`}
        type="text"
        onClick={() => swithStep(-1)}
      >
        <img src={ImgArrowLeft} alt="" />
      </Button>
      {items.map((itm: any, index: number) => (
        <div
          key={index + 1}
          className={`step step${index + 1} ${
            state.step !== index + 1 ? 'hide' : ''
          }`}
        >
          <img src={getImg(itm.img)} alt="" />
          <div className="step-text">
            <div className="name">{itm.name}</div>
            <div className="text">{itm.text}</div>
          </div>
        </div>
      ))}
      {state.completed || <img className="point" src={ImgPoint} alt="" />}
      <Button
        className={`next-button ${state.step === 3 ? 'hide' : ''}`}
        type="text"
        onClick={() => swithStep(1)}
      >
        <img src={ImgArrowRight} alt="" />
      </Button>
      <div className="step-dots">
        <div className={`step-dot ${state.step === 1 ? 'active' : ''}`} />
        <div className={`step-dot ${state.step === 2 ? 'active' : ''}`} />
        <div className={`step-dot ${state.step === 3 ? 'active' : ''}`} />
      </div>
    </div>
  );
};

export default Animation044;
